// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicCaseStudies: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="53" viewBox="0 0 40 53" fill="currentColor">
            <path
                fill="currentColor"
                d="M1054.5,2189.5 L1054.5,2202.5 L1067.5,2202.5 L1054.5,2189.5 Z M1051.25,2202.5 L1051.25,2189.5 L1033.375,2189.5 C1030.68258,2189.5 1028.5,2191.68258 1028.5,2194.375 L1028.5,2236.625 C1028.5,2239.31641 1030.68258,2241.5 1033.375,2241.5 L1062.625,2241.5 C1065.31742,2241.5 1067.5,2239.31742 1067.5,2236.625 L1067.5,2205.75 L1054.59141,2205.75 C1052.70234,2205.75 1051.25,2204.29766 1051.25,2202.5 Z M1041.5,2233.71016 C1041.5,2234.35 1040.85,2235 1040.21016,2235 L1036.3,2235 C1035.64797,2235 1035,2234.35 1035,2233.71016 L1035,2226.55 C1035,2225.9 1035.64797,2225.25 1036.29492,2225.25 L1040.20508,2225.25 C1040.85,2225.25 1041.5,2225.9 1041.5,2226.55 L1041.5,2233.71016 Z M1051.25,2233.71016 C1051.25,2234.35 1050.6,2235 1049.96016,2235 L1046.05,2235 C1045.4,2235 1044.75,2234.35 1044.75,2233.71016 L1044.75,2213.55 C1044.75,2212.9 1045.4,2212.25 1046.05,2212.25 L1049.96016,2212.25 C1050.6,2212.25 1051.25,2212.9 1051.25,2213.55 L1051.25,2233.71016 Z M1055.8,2218.75 L1059.71016,2218.75 C1060.35,2218.75 1061,2219.4 1061,2220.05 L1061,2233.71016 C1061,2234.35 1060.35,2235 1059.71016,2235 L1055.8,2235 C1055.15,2235 1054.5,2234.35 1054.5,2233.71016 L1054.5,2220.05 C1054.5,2219.4 1055.15,2218.75 1055.8,2218.75 Z"
                transform="translate(-1028 -2189)"
            />
        </svg>
    );
};

export default React.memo(GraphicCaseStudies);
